import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';
const ax = axios.create({ baseURL: API, withCredentials: true });

const s = {
  wrap: { padding: '32px 40px', maxWidth: 1200, margin: '0 auto' },
  label: { display: 'block', fontSize: '0.7rem', color: '#444', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 6 },
  input: { width: '100%', background: '#0d0d0d', border: '1px solid #1e1e1e', borderRadius: 8, padding: '10px 14px', color: '#F0F0F0', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box' },
  btn: { background: '#C8FF00', color: '#000', border: 'none', borderRadius: 8, padding: '11px 28px', fontWeight: 800, fontSize: '0.82rem', letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#888', border: '1px solid #1e1e1e', borderRadius: 8, padding: '8px 18px', fontWeight: 700, fontSize: '0.78rem', letterSpacing: '0.05em', textTransform: 'uppercase', cursor: 'pointer' },
  card: { background: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: 12, padding: 24, marginBottom: 16 },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 },
  tab: (active) => ({ padding: '8px 20px', borderRadius: 6, fontWeight: 700, fontSize: '0.78rem', letterSpacing: '0.05em', textTransform: 'uppercase', cursor: 'pointer', border: 'none', background: active ? '#C8FF00' : 'transparent', color: active ? '#000' : '#555', transition: 'all 0.15s' }),
  viewTab: (active) => ({ padding: '6px 16px', borderRadius: 6, fontWeight: 700, fontSize: '0.72rem', letterSpacing: '0.05em', textTransform: 'uppercase', cursor: 'pointer', border: '1px solid', borderColor: active ? '#C8FF00' : '#1e1e1e', background: active ? 'rgba(200,255,0,0.08)' : 'transparent', color: active ? '#C8FF00' : '#555', transition: 'all 0.15s' }),
};

const DATA_OPTIONS = [
  { id: 'email',     label: 'Courriel' },
  { id: 'telephone', label: 'Téléphone' },
  { id: 'paiement',  label: 'Paiement' },
  { id: 'analytics', label: 'Analytics / Cookies' },
  { id: 'compte',    label: 'Création de compte' },
  { id: 'adresse',   label: 'Adresse postale' },
  { id: 'formulaire',label: 'Formulaires de contact' },
  { id: 'ip',        label: 'Adresse IP / logs' },
];

export default function LegalGeneratorSection() {
  const [form, setForm] = useState({
    company: '', url: '', businessType: '', services: '',
    contactEmail: '', province: 'Québec',
  });
  const [dataCollected, setDataCollected] = useState(['email', 'formulaire', 'analytics']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const [docTab, setDocTab] = useState('terms');
  const [viewTab, setViewTab] = useState('preview');
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState('');

  useEffect(() => {
    ax.get('/api/clients').then(r => setClients(r.data || [])).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const toggleData = (id) => {
    setDataCollected(d => d.includes(id) ? d.filter(x => x !== id) : [...d, id]);
  };

  const generate = async () => {
    if (!form.company || !form.contactEmail) {
      setError('Nom de l\'entreprise et courriel de contact requis.');
      return;
    }
    setError('');
    setLoading(true);
    setResult(null);
    try {
      const dataLabel = dataCollected.map(id => DATA_OPTIONS.find(o => o.id === id)?.label).filter(Boolean).join(', ');
      const { data } = await ax.post('/api/legal/generate', {
        ...form,
        dataCollected: dataLabel,
        clientId: selectedClientId || undefined,
      });
      setResult(data);
      setDocTab('terms');
      setViewTab('preview');
    } catch (e) {
      setError(e.response?.data?.error || 'Erreur lors de la génération.');
    } finally {
      setLoading(false);
    }
  };

  const currentDoc = result ? (docTab === 'terms' ? result.terms : result.privacy) : '';
  const docLabel   = docTab === 'terms' ? 'conditions_utilisation' : 'politique_confidentialite';

  const download = () => {
    const blob = new Blob([currentDoc], { type: 'text/html;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${form.company.toLowerCase().replace(/\s+/g, '-')}_${docLabel}.html`;
    a.click();
  };

  const copy = () => {
    navigator.clipboard.writeText(currentDoc);
  };

  return (
    <div style={s.wrap}>
      {/* Header */}
      <div style={{ marginBottom: 32 }}>
        <div style={{ fontSize: '0.65rem', color: '#333', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 8 }}>Générateur IA</div>
        <h2 style={{ margin: 0, fontSize: '1.6rem', fontWeight: 900, color: '#F0F0F0', letterSpacing: '-0.02em' }}>Pages légales</h2>
        <p style={{ margin: '8px 0 0', color: '#555', fontSize: '0.85rem' }}>Génère automatiquement les Conditions d'utilisation et la Politique de confidentialité (Loi 25) pour un client.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: result ? '380px 1fr' : '1fr', gap: 24, alignItems: 'start' }}>
        {/* Formulaire */}
        <div style={s.card}>
          <div style={{ fontSize: '0.68rem', color: '#444', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 20 }}>Informations client</div>

          <div style={{ marginBottom: 14 }}>
            <label style={s.label}>Nom de l'entreprise *</label>
            <input style={s.input} value={form.company} onChange={set('company')} placeholder="Ex: Café Montréal" />
          </div>

          <div style={s.row}>
            <div>
              <label style={s.label}>URL du site</label>
              <input style={s.input} value={form.url} onChange={set('url')} placeholder="https://..." />
            </div>
            <div>
              <label style={s.label}>Province</label>
              <select style={{ ...s.input, cursor: 'pointer' }} value={form.province} onChange={set('province')}>
                <option>Québec</option>
                <option>Ontario</option>
                <option>Alberta</option>
                <option>Colombie-Britannique</option>
              </select>
            </div>
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={s.label}>Type d'entreprise</label>
            <input style={s.input} value={form.businessType} onChange={set('businessType')} placeholder="Ex: Restaurant, Agence web, Boutique en ligne…" />
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={s.label}>Services / produits offerts</label>
            <textarea style={{ ...s.input, minHeight: 70, resize: 'vertical' }} value={form.services} onChange={set('services')} placeholder="Ex: Livraison de repas, réservation en ligne, vente de produits…" />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ ...s.label, marginBottom: 12 }}>Données collectées</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {DATA_OPTIONS.map(o => {
                const active = dataCollected.includes(o.id);
                return (
                  <button key={o.id} onClick={() => toggleData(o.id)} style={{ padding: '5px 12px', borderRadius: 100, fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', border: '1px solid', borderColor: active ? '#C8FF00' : '#1e1e1e', background: active ? 'rgba(200,255,0,0.1)' : 'transparent', color: active ? '#C8FF00' : '#444', transition: 'all 0.15s' }}>
                    {o.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={s.label}>Courriel de contact légal *</label>
            <input style={s.input} value={form.contactEmail} onChange={set('contactEmail')} placeholder="legal@votreentreprise.com" type="email" />
          </div>

          <div style={{ marginBottom: 20, padding: '12px 14px', background: 'rgba(200,255,0,0.04)', border: '1px solid rgba(200,255,0,0.1)', borderRadius: 8 }}>
            <label style={{ ...s.label, color: '#C8FF00', marginBottom: 8 }}>Facturer sur le compte Claude de :</label>
            <select style={{ ...s.input, cursor: 'pointer' }} value={selectedClientId} onChange={e => setSelectedClientId(e.target.value)}>
              <option value="">Mon compte (défaut)</option>
              {clients.filter(c => c.anthropicApiKey).map(c => (
                <option key={c.id} value={c.id}>{c.name} — {c.company || c.email}</option>
              ))}
            </select>
            {clients.length > 0 && clients.filter(c => c.anthropicApiKey).length === 0 && (
              <div style={{ fontSize: '0.7rem', color: '#444', marginTop: 6 }}>Aucun client n'a encore configuré sa clé API Claude. Modifie une fiche client dans le CRM pour en ajouter une.</div>
            )}
          </div>

          {error && <div style={{ color: '#f87171', fontSize: '0.8rem', marginBottom: 14 }}>{error}</div>}

          <button onClick={generate} disabled={loading} style={{ ...s.btn, width: '100%', opacity: loading ? 0.6 : 1 }}>
            {loading ? '⏳ Génération en cours…' : '✦ Générer les pages légales'}
          </button>
        </div>

        {/* Résultat */}
        {result && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {/* Onglets documents */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              <button style={s.tab(docTab === 'terms')} onClick={() => setDocTab('terms')}>Conditions d'utilisation</button>
              <button style={s.tab(docTab === 'privacy')} onClick={() => setDocTab('privacy')}>Politique de conf. (Loi 25)</button>
            </div>

            {/* Toolbar */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
              <div style={{ display: 'flex', gap: 6 }}>
                <button style={s.viewTab(viewTab === 'preview')} onClick={() => setViewTab('preview')}>Aperçu</button>
                <button style={s.viewTab(viewTab === 'code')} onClick={() => setViewTab('code')}>Code HTML</button>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={copy} style={s.btnGhost}>Copier</button>
                <button onClick={download} style={{ ...s.btnGhost, borderColor: '#C8FF00', color: '#C8FF00' }}>↓ Télécharger .html</button>
              </div>
            </div>

            {/* Contenu */}
            <div style={{ background: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: 12, overflow: 'hidden' }}>
              {viewTab === 'preview' ? (
                <iframe
                  srcDoc={currentDoc}
                  title="Aperçu"
                  style={{ width: '100%', height: 620, border: 'none', display: 'block', background: '#fff' }}
                  sandbox="allow-same-origin"
                />
              ) : (
                <pre style={{ margin: 0, padding: 24, overflow: 'auto', maxHeight: 620, fontSize: '0.75rem', color: '#888', lineHeight: 1.6, fontFamily: '"JetBrains Mono", "Fira Code", monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {currentDoc}
                </pre>
              )}
            </div>

            {/* Info */}
            <div style={{ marginTop: 12, padding: '12px 16px', background: 'rgba(200,255,0,0.04)', border: '1px solid rgba(200,255,0,0.12)', borderRadius: 8 }}>
              <div style={{ fontSize: '0.75rem', color: '#888', lineHeight: 1.6 }}>
                <strong style={{ color: '#C8FF00' }}>Comment utiliser</strong> — Télécharge le fichier .html et dépose-le à la racine du site du client. Ajoute un lien dans le footer vers <code style={{ color: '#aaa' }}>/conditions-utilisation.html</code> et <code style={{ color: '#aaa' }}>/politique-confidentialite.html</code>.
              </div>
            </div>
          </div>
        )}

        {/* État vide si pas encore de résultat et grand écran */}
        {!result && (
          <div style={{ display: 'none' }} />
        )}
      </div>
    </div>
  );
}
